import { Link, useLocation } from "react-router-dom";


const classNames = (...classes) => {
  return classes.filter(Boolean).join(' ')
}


export function ExactNavLink({ to, children }) {
  const location = useLocation();

  const target =
    typeof to === "string"
      ? encodeURI(to.slice(2))
      : `${to.pathname || ""}${to.search || ""}${to.hash || ""}`;

  const current =
    `${location.pathname}${location.search}${location.hash}`;

  const isActive = current === target;
//   console.log('to',encodeURI(to.slice(2)),'current',current,'isActive', isActive)

  return (
    <Link
      to={to}
      className={[
        "group text-lg inline-flex items-center border-b-2  my-1 px-1 font-medium hover:no-underline",
        isActive
          ? "border-[#FBCD44] text-black"
          : "border-transparent text-[#4E525C] hover:border-gray-300 hover:text-black",
      ].join(" ")}
    //   aria-current={isActive ? "page" : undefined}
    >
      {children}
    </Link>
  );
}